
import { useQuery } from "@tanstack/react-query";
import { vacancyStatusSettingsService } from "@/services/vacancyStatusSettingsService";

// query keys
export const vacancyStatusSettingsQueryKeys = {
    all: ["vacancyStatusSettings"],
    list: () => [...vacancyStatusSettingsQueryKeys.all, "list"],
    details: (vacancyId, vacancyStatusId) => [...vacancyStatusSettingsQueryKeys.all, "detail", vacancyId, vacancyStatusId],
};



// get vacancy status settings by vacancy id
export const useVacancyStatusSettingsByVacancyId = (vacancyId, vacancyStatusId, enabled = true) => {
    console.log('useVacancyStatusSettingsByVacancyId called with:', { vacancyId, vacancyStatusId, enabled });
    return useQuery({
        queryKey: [...vacancyStatusSettingsQueryKeys.details(vacancyId, vacancyStatusId)],
        queryFn: () => vacancyStatusSettingsService.getVacancyStatusSettingsByVacancyId(vacancyId, vacancyStatusId),
        enabled: !!(vacancyId && vacancyStatusId && enabled), // Only run when all conditions are met
    });
};
